import { SET_RUNNING_IMPORTS, CLEAR_RUNNING_IMPORTS, COMPLETE_RUNNING_IMPORTS } from "../actions/types";

//Handling quick import processes
export const quickImportReducer = (state = [], { type, payload }) => {
  switch (type) {
    case SET_RUNNING_IMPORTS:
      const process = state.find((process) => process.historyId === payload.historyId && payload.runningProcesses);
      if (process) {
        process.runningProcesses = payload.runningProcesses;
        return [...state];
      } else {
        const foundProcess = state.findIndex((process) => process.historyId === payload.historyId);

        if (foundProcess > -1) {
          state[foundProcess] = {
            historyId: payload.newHistoryId || payload.historyId,
            workspace: payload.workspace,
            isRunning: true,
            filename: payload.filename,
            runningProcesses: payload.runningProcesses,
            schemaName: payload.schemaName,
            tableName: payload.tableName,
            type: payload.type,
            error: payload.error,
          };

          return [...state];
        } else {
          return [
            ...state,
            {
              historyId: payload.historyId,
              workspace: payload.workspace,
              isRunning: true,
              filename: payload.filename,
              runningProcesses: payload.runningProcesses,
              schemaName: payload.schemaName,
              tableName: payload.tableName,
              type: payload.type,
              error: payload.error,
            },
          ];
        }
      }

    case COMPLETE_RUNNING_IMPORTS:
      return state.map((process) =>
        process.historyId === payload.historyId
          ? {
              ...process,
              isRunning: false,
              success: payload.success,
              warning: payload.warning,
              error: payload.error,
            }
          : process
      );

    case CLEAR_RUNNING_IMPORTS:
      return state.filter((process) => process.historyId !== payload.historyId);
    default:
      return state;
  }
};
